import { Component, input } from '@angular/core';

import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'reports-visualization-title',
  templateUrl: './visualization-title.component.html',
  styleUrls: ['./visualization-title.component.less'],
  imports: [IconComponent, RtTooltip],
})
export class ReportsVisualizationTitleComponent {
  public name = input.required<string>();
  public description = input<string>();
  public size = input<'medium' | 'small'>('small');
}
